import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { colors, spacings } from "@ui/Theme";
import { fontSizes } from "@ui";

export const headerActions = css`
  justify-self: end;
  grid-column: 2 / span 1;
  grid-row: 1 / span 2;
  z-index: 1;
`;

export const headerTitle = css`
  grid-column: 1 / span 1;
  grid-row: 2 / span 1;
  color: ${colors.carbon900};
  font-size: calc(${fontSizes[10]} - ((${fontSizes[10]} - ${fontSizes[9]}) * var(--p)));
  line-height: calc(36px + ((36 - 30) * var(--p)));

  @media print {
    font-size: ${fontSizes[10]};
    line-height: 36px;
  }
`;

export const headerStatus = css`
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
`;

export const headerWithScrollAnimation = css`
  @media screen {
    position: sticky;
    > * {
      z-index: 1;
    }
    &::before {
      content: "";
      display: block;
      /* position: absolute; */
      width: calc(100% + (var(--h-padding) * 2));
      height: calc(100% + 16px + var(--top-padding));
      margin-top: calc(-1 * var(--top-padding));
      margin-left: calc(-1 * var(--h-padding));
      background: linear-gradient(
        to bottom,
        rgba(250, 251, 255, 1) 0%,
        rgba(250, 251, 255, 1) 85%,
        rgba(250, 251, 255, 0) 100%
      );
      z-index: 0;
      grid-column: 1 / span 2;
      grid-row: 1 / span 2;
    }
  }
`;

export const Header = styled.header`
  --p: var(--sticky-header-animation-progress, 0);
  --top-padding: calc(${spacings.xl} - (16px * var(--p)));
  --h-padding: 32px;

  align-self: start;
  column-gap: 24px;
  display: grid;
  gap: 4px;
  grid-auto-rows: max-content;
  grid-template-columns: 1fr max-content;
  padding: var(--top-padding) 0;
  top: calc(var(--primary-header-height));
  z-index: 2;
  grid-column: 1 / span 3 !important;
  margin-left: 6px;

  @media print {
    margin-bottom: ${spacings.xl};
    padding-left: 0;
    padding-right: 0;
  }

  & > :not(:is(.${headerActions}, .${headerTitle}, .${headerStatus})) {
    grid-column: 1 / span 1;
  }
`;

export const HeaderDescription = css`
  color: ${colors.carbon800};
  grid-row: 3 / span 1;
  opacity: calc(1 - var(--p));

  @media print {
    opacity: 1 !important;
  }
`;
